import React from 'react';

import styles from './jobVaultShowBlockStyles';

const JobVaultShowBlock = ({ title, Component, text, ...props }) => (
  <div id={title.replace(' ', '-')} className={styles.container}>
    <h4 className={styles.title}>{title}</h4>
    {Component ? <Component {...props} /> : <div className={styles.text}>{text}</div>}
  </div>
);

export default JobVaultShowBlock;
